<div (click)="onClick.emit(true)" class="badge btn  bg-light border text-dark ml-auto d-flex align-items-center p-2 " ><i class="fa-solid"
    [class.fa-bars-filter]=" selected" [class.icon-blank]="!selected" 
    [class.fa-flip-vertical]="direction !== SortDirection.Desc" aria-hidden="true"></i>
  <span class="pl-2" >
    {{name}}
  </span>
</div>
